import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpErrorHandlerService} from '../raintree/http-error-handler.service';
import {catchError, Observable} from 'rxjs';
import {JWTResponse} from './model/jwtresponse';
import {HeimdallService} from './heimdall.service';
import {JWTService} from './jwt.service';
import {Router} from '@angular/router';
// import { UserTransmissionService } from '../raintree/transmission/user-transmission.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ToastMessageService} from '../services/toast-message.service';
import {isPlatformBrowser} from '@angular/common';
import {LocalStorageService} from "@bloomscorp/ngbase";
import {AuthProviderEnum} from "./enum/auth-provider-enum";
import {RequestMapperService} from "../request-mapper.service";

@UntilDestroy()
@Injectable({
	providedIn: 'root',
})
export class AuthenticationService {

	public isBrowser: boolean = false;

	constructor(
		private _http: HttpClient,
		private _httpErrorHandler: HttpErrorHandlerService,
		private _jwtService: JWTService,
		private _router: Router,
		private _storage: LocalStorageService,
		private _heimdall: HeimdallService,
		public _toast: ToastMessageService,
		@Inject(PLATFORM_ID) private _platformId: Object
		// private _profileApi: UserTransmissionService
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}


	isLogedIn = false;

	private onAuthenticationSuccess(response: JWTResponse): void {
		//TODO: implement auth State subject
		try {
			this._jwtService.prepareJWT(response.jwt);
			this.setAuthority();
			if(!this.isBrowser){
				return
			}
			//TODO: fix this redirection method
			if(localStorage.getItem('returnUrl')){
				this._router
					.navigateByUrl(localStorage.getItem('returnUrl') || '')
					.then((success) => {
						if (success) {
							this.isLogedIn = true;
							if(this.isBrowser) {
								localStorage.removeItem('returnUrl');
								window.location.reload();
							}
						}
					});
			}
			else if (localStorage.getItem("storeUrl")) {
				if (this.isBrowser) {
					window.location.href = localStorage.getItem("storeUrl")!
					localStorage.removeItem("storeUrl");
					this.isLogedIn = true;
				}
			}

		} catch (Error: any) {
			// this._snackService.error(Error.message);
		}
	}

	public setAuthority(): void {
		if (this._jwtService.hasValidJWT()) {

		}
		// this._profileApi.resolveAuthorityToken(
		// 	() => {
		// 		// this._snackService.loading(MessageService.AUTHORIZING)
		// 	},
		// 	(response: Authority) => { },
		// 	(response: Authority) => {
		// 		this._heimdall.prepareJudiciary(response);
		// 		HeimdallService.authResolver$.next(null);
		// 	},
		// 	(error: string) => {
		// 		// this._snackService.error(error),
		// 	},

		// 	() => {
		// 		// this._snackService.close()
		// 	}
		// );
	}

	public getJWT(
		username: string,
		password: string,
		onComplete: () => void
	): Observable<JWTResponse> {
		return this._http
			.post<JWTResponse>(RequestMapperService.AUTHENTICATION_URL, {
				username,
				password,
			})
			.pipe(
				catchError((err: any) => {
					onComplete();
					return this._httpErrorHandler.interceptJWTError(err);
				})
			);
	}

	public getJWTEmail(
		username: string,
		password: string,
		onComplete: () => void
	): Observable<JWTResponse> {
		return this._http
			.post<JWTResponse>(RequestMapperService.AUTHENTICATION_EMAIL_URL, {
				username,
				password,
			})
			.pipe(
				catchError((err: any) => {
					onComplete();
					return this._httpErrorHandler.interceptJWTError(err);
				})
			);
	}

	public getOAuthJWT(
		username: string,
		password: string,
		provider: AuthProviderEnum,
		onComplete: () => void
	): Observable<JWTResponse> {
		return this._http
			.post<JWTResponse>(RequestMapperService.AUTHENTICATION_SOCIAL_URL, {
				username,
				password,
				provider
			})
			.pipe(
				catchError((err: any) => {
					onComplete();
					return this._httpErrorHandler.interceptJWTError(err);
				})
			);
	}

	public authenticate(
		username: string,
		password: string,
		onSuccess: () => void = () => { },
		onFailure: () => void = () => { },
		onComplete: () => void = () => { }
	): void {
		this.getJWT(username, password, onComplete)
			.pipe(
				untilDestroyed(this)
			)
			.subscribe(
				(response) => {
					// debugger
					onSuccess();
					this.onAuthenticationSuccess(<JWTResponse>response);
				},
				(error) => {
					// this._snackService.warning(error);
					this._toast.error(error, error);
					onFailure();
				},
				() => onComplete()
			);
	}

	public authenticateEmail(
		username: string,
		password: string,
		onSuccess: () => void = () => { },
		onFailure: (error: string) => void = () => { },
		onComplete: () => void = () => { }
	): void {
		this.getJWTEmail(username, password, onComplete)
			.pipe(
				untilDestroyed(this)
			)
			.subscribe(
				(response) => {
					// debugger
					onSuccess();
					this.onAuthenticationSuccess(<JWTResponse>response);
				},
				(error) => {
					// this._snackService.warning(error);
					this._toast.error(error, error);
					onFailure(error);
				},
				() => onComplete()
			);
	}

	public authenticateSocial(
		username: string,
		password: string,
		provider: AuthProviderEnum,
		onSuccess: () => void = () => { },
		onFailure: () => void = () => { },
		onComplete: () => void = () => { }
	): void {
		this.getOAuthJWT(username, password, provider, onComplete)
			.pipe(
				untilDestroyed(this)
			)
			.subscribe(
				(response) => {
					// debugger
					onSuccess();
					this.onAuthenticationSuccess(<JWTResponse>response);
				},
				(error) => {
					// this._snackService.warning(error);
					this._toast.error(error, error);
					onFailure();
				},
				() => onComplete()
			);
	}


	public verifyEmailToken(
		token: string,
		onComplete: () => void
	): Observable<JWTResponse> {
		return this._http
			.post<JWTResponse>(RequestMapperService.CONFIRM_EMAIL_URL, {
				token: token
			})
			.pipe(
				catchError((err: any) => {
					onComplete();
					return this._httpErrorHandler.interceptJWTError(err);
				})
			);
	}
	public verifyEmailTokenAndLogin(
		token: string,
		onSuccess: () => void = () => { },
		onFailure: () => void = () => { },
		onComplete: () => void = () => { }
	): void {
		this.verifyEmailToken(token, onComplete)
			.pipe(
				untilDestroyed(this)
			)
			.subscribe(
				(response) => {
					// debugger
					onSuccess();
					this.onAuthenticationSuccess(<JWTResponse>response);
				},
				(error) => {
					// this._snackService.warning(error);
					this._toast.error(error, error);
					onFailure();
				},
				() => onComplete()
			);
	}
}
